
module.exports = {
  REQUEST_MODAL: 'REQUEST_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
}
